import { INSTRUMENTS_BY_TYPE, InstrumentType } from '@fretgenius/core/music-theory-service';

import { AccidentalPreference, FretboardInitialConfig } from '../types';
import { resolveValidTuningId, validateInstrumentDefaults } from './tuningUtils';

export interface InitialFretboardUIConfig {
  instrumentType: InstrumentType;
  tuningId: string;
  numFrets: number;
  heightRatio: number;
  useEqualTemperament: boolean;
  useTrapezoidScaling: boolean;
  noteCircleScale: number;
  isLeftHanded: boolean;
  accidentalPreference: AccidentalPreference;
  fretWidthBase: number;
  showFretMarkerLabels: boolean;
}

export function computeInitialConfig(
  input: FretboardInitialConfig | undefined,
  reportErrorFn: (error: unknown, context?: Record<string, unknown>) => void
): InitialFretboardUIConfig {
  const instrumentType = input?.instrumentType ?? InstrumentType.Guitar;

  validateInstrumentDefaults(instrumentType, 'init', reportErrorFn);

  const defaultTuningId = INSTRUMENTS_BY_TYPE[instrumentType]?.defaultTunings[0]?.id ?? '';
  const tuningId = resolveValidTuningId(
    instrumentType,
    input?.tuningId ?? defaultTuningId,
    'init',
    reportErrorFn
  );

  const numFrets = input?.numFrets ?? INSTRUMENTS_BY_TYPE[instrumentType].defaultNumFrets;

  return {
    instrumentType,
    tuningId,
    numFrets,
    heightRatio: input?.heightRatio ?? 0.4,
    useEqualTemperament: input?.useEqualTemperament ?? false,
    useTrapezoidScaling: input?.useTrapezoidScaling ?? true,
    noteCircleScale: input?.noteCircleScale ?? 0.8,
    isLeftHanded: input?.isLeftHanded ?? false,
    accidentalPreference: input?.accidentalPreference ?? AccidentalPreference.Sharp,
    fretWidthBase: input?.fretWidthBase ?? 35,
    showFretMarkerLabels: input?.showFretMarkerLabels ?? true,
  };
}
